// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { type Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';

export class ProductMarginOverview {
  readonly id: string;
  readonly alternateId: string;
  readonly name: string;
  readonly targetMarginPercentageOverride: string | null;
  readonly minimumMarginPercentageOverride: string | null;
  readonly targetMarginFlatAmountOverride: Currency | null;
  readonly minimumMarginFlatAmountOverride: Currency | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? '' : data.id;
    this.alternateId = data.alternateId === undefined ? '' : data.alternateId;
    this.name = data.name === undefined ? '' : data.name;
    this.targetMarginPercentageOverride =
      data.targetMarginPercentageOverride === undefined
        ? null
        : data.targetMarginPercentageOverride;
    this.minimumMarginPercentageOverride =
      data.minimumMarginPercentageOverride === undefined
        ? null
        : data.minimumMarginPercentageOverride;
    this.targetMarginFlatAmountOverride =
      (data.targetMarginFlatAmountOverride ?? null) === null
        ? null
        : NewCurrency(data.targetMarginFlatAmountOverride);
    this.minimumMarginFlatAmountOverride =
      (data.minimumMarginFlatAmountOverride ?? null) === null
        ? null
        : NewCurrency(data.minimumMarginFlatAmountOverride);
  }

  static zero(): ProductMarginOverview {
    const zeroValues: ExcludeMethodsDeep<ProductMarginOverview> = {
      id: '',
      alternateId: '',
      name: '',
      targetMarginPercentageOverride: null,
      minimumMarginPercentageOverride: null,
      targetMarginFlatAmountOverride: null,
      minimumMarginFlatAmountOverride: null,
    };
    return new ProductMarginOverview(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProductMarginOverviewWireFormat = {
  id: string;
  alternateId: string;
  name: string;
  targetMarginPercentageOverride: string | null;
  minimumMarginPercentageOverride: string | null;
  targetMarginFlatAmountOverride: CurrencyWireFormat | null;
  minimumMarginFlatAmountOverride: CurrencyWireFormat | null;
};

type NewProductMarginOverviewProps = PartialDeep<
  ProductMarginOverview,
  { recurseIntoArrays: true }
>;
export const NewProductMarginOverview: (
  props: NewProductMarginOverviewProps,
) => ProductMarginOverview = (props) => new ProductMarginOverview(props);

type NewProductMarginOverviewFromWireFormatProps = PartialDeep<
  ProductMarginOverviewWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProductMarginOverviewFromWireFormat: (
  props: NewProductMarginOverviewFromWireFormatProps,
) => ProductMarginOverview = (props) => new ProductMarginOverview(props);
